<template>
  <div>
    <span v-if="deviceIcon" class="device-icon-container">
      <img class="device-icon" :src="deviceIconUrl" />
    </span>
    <span
      v-if="activityIconVisible"
      class="activity-icon-container"
      :style="`background-color: ${iconColor};`"
    >
      <img class="activity-icon" :src="activityIcon" />
    </span>
  </div>
</template>

<script>
import iconUtil from '../../utils/icon-util'
import * as misc from '../../enums/misc'
export default {
  name: 'thumbnail-slider-icon',
  props: {
    activityIcon: {
      type: String
    },
    deviceIcon: {
      type: Boolean
    },
    iconColor: {
      type: String,
      default: ''
    },
    collaboration: {
      type: Boolean
    }
  },
  data() {
    return {
      deviceIconUrl: iconUtil.resolve(misc.DEVICE_ICON)
    }
  },
  computed: {
    activityIconVisible() {
      return this.activityIcon && !this.collaboration
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/colours.scss';
.device-icon {
  margin: 6px 0 5px 3px;
}
.activity-icon {
  margin: 1px;
  width: 36px;
  height: 36px;
}
.device-icon-container {
  margin: 70px 0 0 90px;
  background-color: white;
  z-index: 2;
  position: absolute;
  border-radius: 2px;
  width: 37px;
  height: 33px;
}
.activity-icon-container {
  margin: 62px 0 0 88px;
  background-color: white;
  z-index: 2;
  position: absolute;
  border-radius: 2px;
  width: 40px;
  height: 40px;
}
</style>


